<template>
  <button class="outline-button" :disabled="disabled" @click="handleClick">
    {{ title }}
  </button>
</template>

<script setup>
// プロパティの定義
defineProps({
  title: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['click']);

const handleClick = () => {
  emit('click');
};
</script>

<style scoped>
.outline-button {
  background: #fff;
  color: #222;
  border: 1px #ccc solid;
  border-radius: 0.5rem;
  font-size: 1.4rem;
  padding: 0.5rem 1rem;
}
</style>
